import { useState } from 'react'
import { useRequest } from '@10000/react'
import { Avatar, Box, Body, H4, Icon, PopUpMenu, Button, Dialog, ItemPill, VerticalDots } from '../../widgets'
import { Form, Text, Submit } from '../../forms'
import { query } from '../../../utilities.js'
import './Participant.scss'

export const Participant = ({ index, name, avatar, isCurrentUser, isPresenter, controls, answered }) => {
  const request = useRequest('squiz')
  const fromUrl = query()

  const [showPopOver, setShowPopOver] = useState(false)
  const [showRename, setShowRename] = useState(false)
  const [showRemove, setShowRemove] = useState(false)

  const renameParticipant = ({ name }) => request('participantRenamed', { index, name }).then(() => setShowRename(false))
  const removeParticipant = () => request('participantRemoved', { index }).then(() => setShowRemove(false))

  return <>
    <ItemPill empty={avatar === undefined}>
      {answered && <Box className="answered-overlay" />}

      <Box className="participant-details" mr={8}>
        <Avatar size="small" index={avatar} />

        <Box fullWidth>
          <Body weight={600} alt align="left">
            {name
              ? (name + ((fromUrl.view !== 'display' && isCurrentUser) ? ' (Me)' : ''))
              : 'Empty'
            }
          </Body>
        </Box>

        {answered && <Icon icon="Tick" fill="white" />}
      </Box>

      {controls && !isPresenter && !answered &&
        <Box zIndex={2} alignSelf="center" mr={8}>
          <Box cursor="pointer" onClick={() => setShowPopOver(true)}>
            <VerticalDots fill="white" />
          </Box>
          <PopUpMenu
            top={0}
            left={-260}
            open={showPopOver}
            onClose={() => {
              setShowPopOver(false)
            }}
            items={[{
              text: 'Change name',
              onClick: () => setShowRename(true)
            }, {
              text: 'Remove',
              onClick: () => setShowRemove(true)
            }]}
          />
        </Box>
      }
    </ItemPill>

    <Dialog open={showRename} onClose={() => setShowRename(false)} showControls={false}>
      <Form onSubmit={renameParticipant} className="participant-dialog-rename-form" values={{ name }}>
        <Box justifyContent="center" fullWidth column gap={16}>
          <Box className="desktop-only">
            <Text dark title="Name" name="name" required />
          </Box>
          <Box className="mobile-only">
            <Text title="Name" name="name" required />
          </Box>
          <Submit fullWidth>Rename</Submit>
        </Box>
      </Form>
    </Dialog>

    <Dialog open={showRemove} onClose={() => setShowRemove(false)} showControls={false}>
      <Box column gap={16} fullWidth>
        <H4 className="participant-dialog-title">
          Are you sure you want to remove {name}?
        </H4>
        <Box gap={16} fullWidth className="participant-dialog-button-container">
          <Button fullWidth onClick={() => setShowRemove(false)}>No</Button>
          <Button fullWidth onClick={removeParticipant}>Yes</Button>
        </Box>
      </Box>
    </Dialog>
  </>
}